const switchInit = () => {
  const switches = document.getElementsByClassName('switch');

  [...switches].forEach((Switch) => {
    Switch.addEventListener('click', () => {
      const SwitchBody = Switch.nextElementSibling;
      Switch.classList.toggle('switch--right');
      SwitchBody.classList.toggle('switch-body--right');
    });
  });
};

export default switchInit;
